import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import GlobalStyles from "@mui/material/GlobalStyles";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton, { listItemButtonClasses } from "@mui/material/ListItemButton";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";

import RestaurantOutlined from "@mui/icons-material/RestaurantOutlined";
import MemoryOutlined from "@mui/icons-material/MemoryOutlined";
import AssignmentRounded from "@mui/icons-material/AssignmentRounded";
import AssignmentTurnedInOutlined from "@mui/icons-material/AssignmentTurnedInOutlined";
import InsightsOutlined from "@mui/icons-material/InsightsOutlined";
import LocalPoliceOutlined from "@mui/icons-material/LocalPoliceOutlined";
import StorefrontOutlined from "@mui/icons-material/StorefrontOutlined";
import CalculateOutlined from "@mui/icons-material/CalculateOutlined";
import GavelOutlined from "@mui/icons-material/GavelOutlined";
import LightModeOutlined from "@mui/icons-material/LightModeOutlined";
import KitchenOutlined from "@mui/icons-material/KitchenOutlined";
import Language from "@mui/icons-material/Language";
import LockPersonOutlined from "@mui/icons-material/LockPersonOutlined";

import { closeSidebar } from "../utils";
import { setMenu } from '../reducer/menu';
import { useMsal } from '@azure/msal-react';
import { JSX } from "react/jsx-runtime";

const menuIcons: { [key: number]: JSX.Element } = {
  0: <LightModeOutlined sx={{ color: "#636B74" }}/>,
  1: <StorefrontOutlined sx={{ color: "#636B74" }}/>,
  2: <CalculateOutlined sx={{ color: "#636B74" }}/>,
  3: <GavelOutlined sx={{ color: "#636B74" }}/>,
  4: <AssignmentRounded color="success"/>,
  5: <KitchenOutlined sx={{ color: "#636B74" }}/>,
  6: <Language sx={{ color: "#636B74" }}/>,
  7: <RestaurantOutlined sx={{ color: "#636B74" }}/>,
  100: <LocalPoliceOutlined color="success"/>,
  200: <AssignmentTurnedInOutlined color="success"/>,
  500: <MemoryOutlined color="success"/>,
  510: <MemoryOutlined color="success"/>,
  800: <AssignmentTurnedInOutlined color="success"/>,
  900: <LockPersonOutlined color="success"/>,
  910: <LockPersonOutlined color="success"/>,
  920: <AssignmentTurnedInOutlined color="success"/>,
  930: <InsightsOutlined color="success"/>
}

const menuItems = [
  // { index: 200, name: 'FAQ사례집', status: 'OPEN', welcome: "신임 OFC가 자주 묻는 질문부터 이슈 해결 노하우까지!\nFAQ사례집을 기반으로 알려드립니다."},
  { index: 0, name: '아리가 알려드려요', status: 'OPEN', welcome: "신임 OFC가 자주 묻는 질문부터 최신 영업 제도까지!\n아리가 열심히 공부해서 알려드립니다."},
  // { index: 800, name: '아리 학습노트', status: 'OPEN', welcome: ""},
];

// const menuItems = [
//   { index: 200, name: 'FAQ사례집', status: 'OPEN', welcome: "신임 OFC가 자주 묻는 질문부터 이슈 해결 노하우까지!\nFAQ사례집을 기반으로 알려드립니다."},
//   { index: 100, name: '월간 영업/제도 안내', status: 'OPEN', welcome: "OFC Value Meeting에서 공유되는 월간 영업안내자료를 확인해보세요.\n\n**12월 4주차 경영주 필독 안내문**\n- 주요 매출 지수 및 상승 카테고리\n- Good Bye 2024 행사 안내\n- 25년 설 신용카드 행사 안내\n- 오징어게임 관련 상품 안내\n- 주간 매출 핵심 상품 안내\n- 오픈런 하는 편의점 25\n\n**AI 를 활용하는 스마트한 OFC 되기**\n**신점포유형 적용 안내**\n**편의점 고객 정의 안내**\n**에이아리  스토어맵 오픈안내**\n**25년 영업 MBO 임시운영(안)**\n**25년 서비스 MBO 평가안**\n**FF 외 폐기가능 상품 월별 재고감모 프로세스 안내**\n**25년 상생지원 및 상생협약 안내**\n**25년 인센티브 제도 운영안 안내**\n**25년 시설 업무 변경사항 요약 공유**"},
//   { index: 0, name: '이오보감', status: 'OPEN', welcome: "이오보감 매뉴얼에서 다양한 정보를 확인해보세요."}
// ];

export default function Sidebar() {
  const { accounts } = useMsal();

  const navigate = useNavigate();
  const selectedMenu = useSelector((state: any) => state.menu);
  const userInfo = useSelector((state: any) => state.user);

  // const [topMenuopen, setTopMenuopen] = useState(true);
  const [alert, setAlert] = useState(false);

  const handleAlertClose = () => {
    setAlert(false);
  };
  
  // 지식 관리는 admin/manager 공통, 사용 현황은 admin 전용
  if (!menuItems.some(item => item.index === 920) &&
      (userInfo.role === 'admin' || userInfo.role === 'manager')) {
    menuItems.push({ index: 920, name: '지식 관리', status: 'OPEN', welcome: "" });
  }

  if (!menuItems.some(item => item.index === 930) && userInfo.role === 'admin') {
    menuItems.push({ index: 930, name: '사용 현황', status: 'OPEN', welcome: "" });
  }

  const dispatch = useDispatch();

  const handleMenuClick = (index: number, name: string, status: string, welcome: string) => {
    if(status === "TBD"){
      setAlert(true);
    }else{
      dispatch(setMenu({index, name, welcome}));
    }
  };

  useEffect(() => {
    if(selectedMenu.selectedIndex < 800) navigate('/');
    else if(selectedMenu.selectedIndex === 800) navigate('/history');
    else if(selectedMenu.selectedIndex === 900) navigate('/console/index');
    // else if(selectedMenu.selectedIndex === 910) navigate('/console/document-manager');
    else if(selectedMenu.selectedIndex === 920) navigate('/console/file-tree');
    else if(selectedMenu.selectedIndex === 930) navigate('/console/usage');
  } , [navigate, selectedMenu]);


  return (
    <Paper
      className="Sidebar"
      sx={{ position: { xs: "fixed", sm: "sticky" },
        transform: {
          xs: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))",
          sm: "none",
        },
        transition: "transform 0.4s, width 0.4s",
        zIndex: 10000,
        height: "100dvh",
        width: "var(--Sidebar-width)",
        top: 0,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        borderRight: "1px solid",
        borderColor: "divider",
      }}
    >
      <GlobalStyles
        styles={(theme) => ({
          ":root": {
            "--Sidebar-width": "220px",
            [theme.breakpoints.up("lg")]: {
              "--Sidebar-width": "240px",
            },
          },
        })}
      />
      <Box
        className="Sidebar-overlay"
        sx={{
          position: "fixed",
          zIndex: 9998,
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          opacity: "var(--SideNavigation-slideIn)",
          backgroundColor: "var(--joy-palette-background-backdrop)",
          transition: "opacity 0.4s",
          transform: {
            xs: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1) + var(--SideNavigation-slideIn, 0) * var(--Sidebar-width, 0px)))",
            lg: "translateX(-100%)",
          },
        }}
        onClick={() => closeSidebar()}
      />
      <Box sx={{ display: "flex", gap: 1, alignItems: "center", p: 2 }}>
        <Avatar 
          // variant="outlined" 
          // size="lg"
          src="/logo.png" />
        <img src="/title-small.png" alt="logo" style={{ width: '145px', height: '35px' }} />
        {/* <Typography fontFamily="'Poetsen One', sans-serif" fontSize={35}>OFC GPT</Typography> */}
      </Box>
      <Box
        sx={{
          minHeight: 0,
          overflow: "hidden auto",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          [`& .${listItemButtonClasses.root}`]: {
            gap: 1.5,
            py: 1,
          },
          px: 2
        }}
      >
        <List sx={{ "--List-nestedInsetStart": "30px" }} >
          {menuItems.map((item, index) => (
            <div key={index}>
              <ListItem key={index} sx={{flexDirection: 'flex-start', px: 0, py: 0.5}} /* secondaryAction={item.child ? (topMenuopen ? <KeyboardArrowDown /> : <KeyboardArrowRight />) : null} */>
                <ListItemButton
                  onClick={/* !item.child ? */ () => handleMenuClick(item.index, item.name, item.status, item.welcome) /* : handleClick */}
                  selected={item.index === selectedMenu.selectedIndex ? true : false}
                  
                  >
                  {menuIcons[item.index]}
                    <Typography 
                      sx={{
                        fontSize: 15, fontWeight: 600, color: item.status === "OPEN" ? "#000" : "#AEB4BA",
                        WebkitFontSmoothing: "antialiased"
                      }}>
                      {item.name}
                    </Typography>
                </ListItemButton>
              </ListItem>
                {/* {topMenuopen && item.child && (<List component="div">
                  {item.child.map((child, childIndex) => {
                    return (
                      <ListItem key={childIndex} sx={{flexDirection: 'flex-start', pl: 2, py: 0}}>
                        <ListItemButton onClick={() => handleMenuClick(child.index, child.name, child.status, child.welcome)}
                          selected={child.index === selectedMenu.selectedIndex ? true : false}>
                          {menuIcons[child.index]}
                            <Typography 
                              // level="title-sm"
                              sx={{
                                fontSize: 15, fontWeight: 600, color: child.status === "OPEN" ? "#000" : "#AEB4BA",
                                WebkitFontSmoothing: "antialiased"
                              }}>
                              {child.name}
                            </Typography>
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>)} */}
              </div>
          ))}
        </List>
      </Box>
      <Divider sx={{}}/>
      {/* <Box sx={{ display: "flex", gap: 1, alignItems: "center", px: 2, py: 1 }}>
        <Avatar />
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography sx={{fontSize: '0.9rem'}}>{accounts[0]['name']}</Typography>
        </Box>
      </Box> */}
      <Dialog
        open={alert}
        onClose={handleAlertClose}
      >
        <DialogTitle id="alert-dialog-title">
          {"메뉴 준비중입니다."}
        </DialogTitle>
      </Dialog>
    </Paper>
  );
}